<birdz-card [isLoading]="isLoading">
  <div card-title>{{ 'BQ_TITLE' | transloco }}</div>
  <div card-corner class="period-buttons">
    <mat-button-toggle-group [value]="period" (change)="selectPeriod($event.value)">
      @for (p of periods; track p.value) {
        <mat-button-toggle [value]="p.value">{{ p.label | transloco }}</mat-button-toggle>
      }
    </mat-button-toggle-group>
  </div>
  <div card-body>
    @if (!isLoading && agRows.length === 0) {
      <p class="no-data">{{ 'BQ_NO_DATA' | transloco }}</p>
    }
    <ag-grid-angular class="usage-grid" [gridOptions]="gridOptions" [columnDefs]="agColumns" [rowData]="agRows" />
  </div>
</birdz-card>
